import { render, staticRenderFns } from "./modalBB.vue?vue&type=template&id=103fe08e&scoped=true&"
import script from "./modalBB.vue?vue&type=script&lang=js&"
export * from "./modalBB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103fe08e",
  null
  
)

export default component.exports